import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _searchResult = [];
let _searchTerm = null;
let _errors = [];

let AppStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addSuccessListener: function(callback) {
        this.addFormSubmitSuccessListener(callback);
        return {remove: () => this.removeFormSubmitSuccessListener(callback)};
    },
    addErrorListener: function(callback) {
        this.addFormSubmitErrorListener(callback);
        return {remove: () => this.removeFormSubmitErrorListener(callback)};
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },

    addFormSubmitSuccessListener: function(callback) {
        this.on(ActionTypes.FORM_SUBMIT_SUCCESS, callback);
    },
    addFormSubmitErrorListener: function(callback) {
        this.on(ActionTypes.FORM_SUBMIT_ERROR, callback);
    },

    addSearchResultListener: function(callback) {
        this.on(ActionTypes.SEARCH_RESULT_RECEIVED, callback);
    },
    removeFormSubmitSuccessListener: function(callback) {
        this.removeListener(ActionTypes.FORM_SUBMIT_SUCCESS, callback);
    },
    removeFormSubmitErrorListener: function(callback) {
        this.removeListener(ActionTypes.FORM_SUBMIT_ERROR, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    removeSearchResultListener: function(callback) {
        this.removeListener(ActionTypes.SEARCH_RESULT_RECEIVED, callback);
    },
    clearErrors: function() {
        if (_errors.length === 0) { return []; } // guard
        const errors = _errors.slice(0);
        _errors = [];
        return errors;
    },

    getLastError: function() {
        const errors = [..._errors];
        let error = errors.pop();
        if (!error || !error.length) {
             error = 'Internal system error';
        }
        return error;
    },
    getSearchResult: function() {
         return _searchResult;
    }
});

AppStore.dispatchToken = CentricDispatcher.register((action) => {


    switch(action.type) {

        // resource saved/updated/deleted successfully
        case ActionTypes.FORM_SUBMIT_SUCCESS:
            AppStore.emit(ActionTypes.FORM_SUBMIT_SUCCESS);
            break;

        // error response from a form submission
        case ActionTypes.FORM_SUBMIT_ERROR:
            _errors.push(action.data);
            AppStore.emit(ActionTypes.FORM_SUBMIT_ERROR);
            break;

        // generic api error
        case ActionTypes.API_ERROR:
            _errors.push( `[${action.data.code}] ${action.data.message}`);
            AppStore.emitChange();
            break;

        case ActionTypes.SEARCH_RESULT_RECEIVED:
            _searchResult = action.data;
            _searchTerm = (!!action.payload && !!action.payload.search ? action.payload.search : null);
            AppStore.emit(ActionTypes.SEARCH_RESULT_RECEIVED);
            break;

        // generic exception handler
        case ActionTypes.API_EXCEPTION:
            console.error('[Exception]', action.data);
            break;

        default:
            if (!!action.type && action.type.endsWith('_FAILURE') && !!action.data && (!action.payload || !action.payload.suppressErrors)) {
                _errors.push(action.data);
                AppStore.emit(ActionTypes.FORM_SUBMIT_ERROR);
            }
            break;

    }
});

export default AppStore;
